var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-container"},[_c('img',{staticClass:"icon-back",attrs:{"src":require("../../../../static/images/bargain/icon-back.png"),"alt":""},on:{"click":_vm.handleBackPage}}),_vm._v(" "),_c('div',{staticClass:"title-text"},[_vm._v(_vm._s(_vm.titleText ? _vm.titleText : "活动规则"))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1ece96b8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/Bargain/components/Title.vue
// module id = null
// module chunks = 